import SectionSubcategory from './SectionSubcategory';
export default SectionSubcategory;
